<div class="row w-100 h-100 color-navi">
  <div class="col-12 p-0 d-flex column ai-center jc-center">
    <p [innerHTML]="'common.errors.authorization-desc' | translate : {user: this.currentUser}"></p>
    <p [innerHTML]="'common.errors.authorization-desc2' | translate : {user: this.currentUser}"></p>
    <p>
      <span>{{'common.label.please'|translate}}</span>
      <span *ngIf="isMimicMode">
        <button class="reset-button link fs-md"
                data-test-id="error_auth_reset_mimic"
                (click)="resetMimic()">{{'common.label.reset-mimic-user' | translate}}</button>
        <span>{{'common.label.or'|translate}}</span>
      </span>
      <button class="reset-button link fs-md"
              data-test-id="error_auth_logout"
              (click)="logout()">{{'common.label.log-out' | translate}}</button>
    </p>
  </div>
</div>
